export default "__VITE_ASSET__CYXIzLNN__"